module.exports = "query getSetupClientSecret($stripeId:String,$mode:String,$order:JsonObject){getSetupClientSecret(stripeId:$stripeId,mode:$mode,order:$order)}"